import React from "react";

const Jared = () => {
  return (
    <>
      <svg
        id="Layer_1"
        height="100%"
        viewBox="0 0 512 512"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
      >
        <path
          d="m504 512v-33.805l-56-126.195h-104-184-96l-56 120v40"
          fill="#3e73a3"
        />
        <path
          d="m176 144-24-40 8-32-32-24 40-16-16-24 72 16 24-16 32 16 56-16-8 24 48 16-24 24 8 32-24 40"
          fill="#1d2b38"
        />
        <path d="m336 144 24-40-8-32h-192l-8 32 24 40z" fill="#0e161c" />
        <path d="m200 264v88l56 56 56-56v-88z" fill="#f7ac79" />
        <path
          d="m200 329.347c52.244 18.922 94.943-7.19 112-20.387v-30.825h-112z"
          fill="#ea8e50"
        />
        <path
          d="m330.413 260.789-45.919 39.359a16 16 0 0 1 -10.413 3.852h-36.162a16 16 0 0 1 -10.413-3.852l-45.919-39.359a16 16 0 0 1 -5.587-12.148v-144.641c0-8.837 23.163-32 32-32h104c8.837 0 24 23.163 24 32v144.641a16 16 0 0 1 -5.587 12.148z"
          fill="#f7ac79"
        />
        <g opacity=".2">
          <path
            d="m291.016 294.557-53.421-38.852a50.121 50.121 0 0 1 -20.607-42.389v-141.316h-8.988c-8.836 0-32 23.164-32 32v144.641a16 16 0 0 0 5.587 12.148l40.915 35.07 5 4.289a16 16 0 0 0 10.416 3.852h36.162a16 16 0 0 0 10.412-3.851z"
            fill="#f9f2ed"
          />
        </g>
        <path d="m176 216-24-24v-48l24 8z" fill="#ef9a60" />
        <path d="m336 216 24-16v-56l-24 8z" fill="#ef9a60" />
        <path
          d="m312 352-56 144-56-144v-24l-40 24v72l40 8-24 32 40 24v24h80v-24l40-24-24-32 40-8-8-72-32-24z"
          fill="#7293b7"
        />
        <path d="m200 352 56 48 56-48-56 144z" fill="#dfdfdd" />
        <g opacity=".2">
          <path
            d="m8 472v3.864c20.241-8.384 40.86-22.091 59.316-40.548 25.857-25.857 42.4-55.956 48.029-83.316h-51.345z"
            fill="#f9f2ed"
          />
        </g>
        <path d="m234.343 133.657 11.314-11.313-8-8a8 8 0 0 0 -5.657-2.344h-32v16h28.687z" />
        <path d="m283.313 128h28.687v-16h-32a8 8 0 0 0 -5.657 2.343l-8 8 11.314 11.313z" />
        <path d="m208 144h16v16h-16z" />
        <path d="m288 144h16v16h-16z" />
        <path d="m285.657 237.657 8-8-11.314-11.313-5.656 5.656h-49.374l-5.656-5.657-11.314 11.313 8 8a8 8 0 0 0 5.657 2.344h56a8 8 0 0 0 5.657-2.343z" />
        <path d="m248 248h16v16h-16z" />
        <path d="m241.694 204.923a8 8 0 0 0 6.306 3.077h32v-16h-21.754l5.515-22.06a7.975 7.975 0 0 0 .239-1.94v-8h-16v7.015l-7.761 31.044a8 8 0 0 0 1.455 6.864z" />
        <path d="m511.313 474.949-56-126.194a8 8 0 0 0 -7.313-4.755h-101.333l-26.667-20v-43.749l15.619-13.388a23.974 23.974 0 0 0 8.381-18.222v-28.36l20.438-13.625a8 8 0 0 0 3.562-6.656v-56a8 8 0 0 0 -10.53-7.589l-9.483 3.161 18.874-31.456a8 8 0 0 0 .9-6.056l-6.9-27.605 20.8-20.8a8 8 0 0 0 -3.127-13.246l-40.415-13.469 5.471-16.41a8 8 0 0 0 -9.79-10.222l-53.006 15.145-29.216-14.608a8 8 0 0 0 -8.016.5l-21.162 14.105-68.665-15.26a8 8 0 0 0 -8.392 12.247l10.53 15.8-30.844 12.335a8 8 0 0 0 -1.829 13.828l27.75 20.813-6.711 26.847a8 8 0 0 0 .9 6.056l18.874 31.456-9.483-3.161a8 8 0 0 0 -10.53 7.589v48a8 8 0 0 0 2.343 5.657l21.657 21.657v29.327a23.976 23.976 0 0 0 8.381 18.222l15.619 13.388v43.749l-26.667 20h-101.333a8 8 0 0 0 -7.249 4.617l-56 120a7.985 7.985 0 0 0 -.751 3.383v40h16v-38.226l53.095-113.774h82.905v64a8 8 0 0 0 6.431 7.845l27.553 5.511-16.384 21.844a8 8 0 0 0 2.284 11.66l36.116 21.669v19.471h16v-24a8 8 0 0 0 -3.884-6.86l-32.393-19.44 18.677-24.9a8 8 0 0 0 -4.831-12.645l-33.569-6.714v-57.441a8 8 0 0 0 4.8-1.6l19.2-14.4v8a7.987 7.987 0 0 0 .55 2.9h-.006l56 144a8 8 0 0 0 14.912 0l56-144h-.006a7.987 7.987 0 0 0 .55-2.9v-8l19.2 14.4a8 8 0 0 0 4.8 1.6v57.441l-33.569 6.714a8 8 0 0 0 -4.831 12.645l18.678 24.9-32.394 19.44a8 8 0 0 0 -3.884 6.86v24h16v-19.471l36.116-21.669a8 8 0 0 0 2.284-11.66l-16.384-21.845 27.553-5.511a8 8 0 0 0 6.431-7.844v-64h82.8l53.2 119.89v32.11h16v-33.806a8 8 0 0 0 -.687-3.245zm-159.313-279.23-8 5.333v-43.286l8-2.667zm-8-80.6v-11.119c0-5.724-4.159-15.529-10.16-24h11.914l5.681 22.726zm-199.812-64.978 26.782-10.713a8 8 0 0 0 3.686-11.865l-4.956-7.435 52.565 11.682a8 8 0 0 0 6.173-1.153l20.138-13.425 27.847 13.924a8 8 0 0 0 5.775.537l41.417-11.833-3.2 9.611a8 8 0 0 0 5.06 10.119l35.715 11.91-12.504 12.5h-84.686v-24h-16v24h-35.056l-13.789-27.578-14.311 7.155 10.212 20.423h-32.389zm22.058 29.859h15.827c-5.662 5.813-14.073 15.823-14.073 24v11.118l-7.436-12.392zm-6.246 108.687v-33.587l8 2.667v38.92zm24 59.955v-144.442c1.208-5.839 18.36-22.992 24.2-24.2h103.457c1.354.53 5.267 3.587 9.906 10.432 4.518 6.668 6.421 12.126 6.437 13.568v144.641a7.991 7.991 0 0 1 -2.793 6.074l-45.92 39.359a8 8 0 0 1 -5.206 1.926h-36.162a8 8 0 0 1 -5.207-1.926l-45.918-39.358a7.994 7.994 0 0 1 -2.794-6.075zm38.3 57.582a24.014 24.014 0 0 0 15.619 5.776h36.162a24.011 24.011 0 0 0 15.618-5.777l14.301-12.258v54.721l-48 48-48-48v-54.72zm33.7 167.704-34.754-89.367 29.1 29.1a8 8 0 0 0 11.314 0l29.1-29.1z" />
        <path d="m112 416h16v96h-16z" />
        <path d="m384 416h16v96h-16z" />
      </svg>
    </>
  );
};

export default Jared;
